import React from 'react';
import gql from 'graphql-tag';
import GqlAutocomplete from './GqlAutocomplete';
import { joinDefined } from '../../utils/strings';

const CremationOrderAutoComplete = ({ category, className, name, clearOnSelect = false, ...props }) => {
    return (
        <GqlAutocomplete
            className={className}
            readAllQuery={readAllCremationOrders}
            placeholder="Cremation order..."
            labelFieldFunc={e =>
                joinDefined(
                    [
                        e.LegacyKey,
                        '-',
                        e.NameOfDeceased ||
                            (e.Deceased && e.Deceased.FirstName,
                            e.Deceased && e.Deceased.MiddleName,
                            e.Deceased && e.Deceased.Surname)
                    ],
                    ' '
                )
            }
            multiple={false}
            name={name}
            clearOnSelect={clearOnSelect}
            {...props}
        />
    );
};

const readAllCremationOrders = gql`
    fragment CremationOrderFragment on CremationOrder {
        ID
        LegacyKey
        NameOfDeceased
        Deceased {
            ID
            FirstName
            Surname
        }
    }

    query ReadCremationOrders($contains: String) {
        readCremationOrders(contains: $contains, limit: 5, offset: 0) {
            edges {
                node {
                    ...CremationOrderFragment
                }
            }
        }
    }
`;

export default CremationOrderAutoComplete;
